/** @format */

export const GOOD_BREAKPOINT = 100;
export const ALMOST_GOOD_BREAKPOINT = 99;
export const NORMAL_BREAKPOINT = 95;
export const UNOPTIMAL_BREAKPOINT = 50;
